import React from 'react';
import { MenuItem } from '@mui/material';
import { SelectOption } from '../model';
import {
  BaseSelectInputProps,
  useSelectInputStyles,
  createSelectInputChangeHandler,
  SelectInputWrapper,
} from './SelectInputShared';

interface SelectInputProps extends BaseSelectInputProps {
  choices: SelectOption[];
  defaultChoice?: SelectOption;
}

const SelectInput: React.FC<SelectInputProps> = (props) => {
  const {
    label,
    onChange,
    valueChanged,
    styleOverrides,
    errorMessage,
    value = '',
    choices,
    defaultChoice,
    disabled = false,
  } = props;

  const classes = useSelectInputStyles();
  const handleChange = createSelectInputChangeHandler(onChange, valueChanged);

  const createMenuItem = (choice: SelectOption) =>
    choice ? (
      <MenuItem value={choice.value} key={choice.value}>
        <span>{choice.label}</span>
      </MenuItem>
    ) : null;

  const defaultMenuItem = createMenuItem(defaultChoice);
  const menuItemChoices = (choices || []).map((choice) => createMenuItem(choice));

  return (
    <SelectInputWrapper
      label={label}
      value={value}
      errorMessage={errorMessage}
      styleOverrides={styleOverrides}
      disabled={disabled}
      classes={classes}
      onChange={handleChange}
    >
      {defaultMenuItem}
      {menuItemChoices}
    </SelectInputWrapper>
  );
};

export default SelectInput;
